const styles = theme => ({
    root: {
        flexBasis: '50%',
        width: props => `${props.fullWidth ? 100 : 50}%`,
        margin: '0 10px',
        marginBottom: '20px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            flexBasis: '100%',
            width: '100% !important'
        }
    },
    input: {
        border: '1px solid rgba(0, 0, 0, 0.5)',
        padding: '8px 12px 7px 12px',
        width: '100%',
        position: 'relative',
        "& input::placeholder": {
            fontWeight: 400,
            fontSize: '14px'
        }
    },
    fontFamily: {
        fontFamily: 'Aktiv Grotesk !important',
        lineHeight: '21px',
        fontSize: '14px',
        fontWeight: '400'
    },
    span: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& div': {
            width: '100%'
        }
    },
    label: {
        margin: '0',
        fontSize: '12px',
        color: '#101010',
        lineHeight: '1rem',
        alignSelf: 'flex-start',
        fontFamily: 'Aktiv Grotesk',
        marginBottom: '.5rem',
        fontWeight: '400'
    },
    '@global': {
        '.MuiFormHelperText-root': {
            position: 'absolute',
            top: '-26px',
            right: '0',
            fontFamily: 'Aktiv Grotesk',
            fontWeight: '400',
            lineHeight: '1rem'
        }
    }
})

export default styles